import PropertyListComponent from "../../propertyNew/PropertyListComponent";

const PropertyCustomer = () => {

  return (  
      <PropertyListComponent
        route={`/dashboard/PropertyDashboard`} 
        apiPath={`/all/property/latestList`}
        method="GET"
        requiresAuth={false}
      /> 
  ); 
};
 
export default PropertyCustomer;